import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import * as yup from 'yup';

var getGenericError = ({
  key,
  message,
  id,
  section
}) => ({
  [key]: {
    id: "genericError" /* GENERIC_ERROR */,
    data: {
      message
    },
    kind: {
      id,
      data: {
        message
      },
      type: "genericError" /* GENERIC_ERROR */,
      section
    }
  }
});
var getLicensesSettingsId = (field) => {
  return `licenseSettings-${field}`;
};
var getLicenseSettingsError = (field) => {
  const objectKey = getLicensesSettingsId(field);
  return getGenericError({
    key: objectKey,
    id: field,
    message: i18n_config_default.t(`settingsModule.licenseSettings.errors.${field}`),
    section: "licenseSettings" /* LICENSE_SETTINGS */
  });
};
var licenseSettingsSchema = yup.object().shape({
  nickname: yup.string().trim().required(getLicenseSettingsError("nickname")),
  registerAutoLock: yup.number().moreThan(-1, getLicenseSettingsError("registerAutoLock")).nullable().typeError(getLicenseSettingsError("registerAutoLock")),
  eGiftCardTerminalId: yup.string().matches(
    /^\d{4}$/,
    JSON.stringify(getLicenseSettingsError("eGiftCardTerminalId"))
  ).required(getLicenseSettingsError("eGiftCardTerminalId"))
});

export { getLicensesSettingsId, licenseSettingsSchema };
